<template>
 <!-- Mobile Menu -->
 <div class="dropdown mobile-user-menu">
    <a href="javascript:void(0);" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>
    <div class="dropdown-menu dropdown-menu-right">
        <router-link class="dropdown-item" @click="signOut" to="/">Logout</router-link>
    </div>
</div>
<!-- /Mobile Menu -->
</template>
<script>
import { signOut as authSignOut } from '../auth';

export default {
    methods: {
        signOut() {
            authSignOut();
        }
    }
}
</script>
